<template>
  <div class="body">
    <div class="header">
      <el-form :model="MiniFindDTO" :inline="true">
        <el-form-item label="上传日期">
          <el-date-picker
            size="small"
            v-model="date"
            type="daterange"
            :picker-options="cellClassName"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            @change="chooeDate"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="下载状态">
        <el-select clearable size="small" v-model="MiniFindDTO.downloadStatus" style="width:120px">
          <el-option
            v-for="item in downloadStatus"
            clearable
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="拼版状态">
        <el-select clearable size="small" v-model="MiniFindDTO.compositionStatus" style="width:120px">
          <el-option
            v-for="item in compositionStatus"
            clearable
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="文件名称">
              <el-input
                size="small"
                v-model="MiniFindDTO.fileName"
                placeholder="文件名称"
              ></el-input>
            </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="serchInfo">
            搜索
          </el-button>
          <el-button @click="submit" size="small" type="primary">下载</el-button>
          <el-button @click="updateComposition" size="small" type="primary">拼版</el-button>
          <el-button @click="unDownLoad" size="small" type="primary">重新下载</el-button>
          <el-button @click="updateUnComposition" size="small" type="primary">重新拼版</el-button>
          <el-button size="small" type="danger" @click="handleDelete">删除</el-button>
        </el-form-item>
        <br>
        <el-form-item>
        <el-button size="small" type="primary" v-for="item in buttonInfo" :key="item" @click="find(item)">
          {{ item }}
         </el-button>
        </el-form-item>
      </el-form>
      <div style="display: flex">
        <!-- <el-button size="small" type="primary">导入</el-button> -->
        <!-- <el-button
          size="small"
          style="margin-left: 10px"
          type="primary"
          @click="exportExcelData"
        >
          导出
        </el-button> -->
      </div>
</div>
<div class="pagination">
                    <el-pagination
                        :current-page="currentPage"
                        :page-sizes="[10, 30, 50, 100]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                    ></el-pagination>
                </div>
    <div style="margin: 10px">
      <el-table
        :data="conTract"
        stripe
        border
        style="width: 100%"
        :cell-style="styleBack"
        @selection-change="handleSelectionChange"
      >
      <el-table-column
        type="selection"
        align="center"
        width="55"
      ></el-table-column>
      <el-table-column
          prop="createTime"
          align="center"
          label="上传时间"
          width="200"
        ></el-table-column>
        <el-table-column
    prop="thumbnail"
    label="缩略图"
    align="center"
    width="450" >
 <template slot-scope="scope">
 <el-popover placement="top-start" trigger="click">
 <!--trigger属性值：hover、click、focus 和 manual-->
 <a :href="scope.row.thumbnail"  target="_blank" title="查看最大化图片">
 <img :src="scope.row.thumbnail" style="max-height: 800px;max-width: 800px">
  </a>
  <img slot="reference" :src="scope.row.thumbnail" style="max-height: 50px;max-width: 50px cursor:pointer">
  </el-popover>
 </template>
</el-table-column>
        <el-table-column
          prop="fileName"
          align="center"
          label="文件名"
        ></el-table-column>
        <el-table-column
          prop="materialType"
          align="center"
          label="材料类型"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="downloadStatus"
          align="center"
          label="下载状态"
          width="100"
        >     <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.downloadStatus==='0'">未下载</el-tag>
          <el-tag type="success" v-if="scope.row.downloadStatus==='1'">已下载</el-tag>
      </template>
      </el-table-column>
        <el-table-column
          prop="compositionStatus"
          align="center"
          label="拼版状态"
          width="100"
        >
        <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.compositionStatus==='0'">未拼版</el-tag>
          <el-tag type="success" v-if="scope.row.compositionStatus==='1'">已拼版</el-tag>
      </template></el-table-column>
      </el-table>
    </div>
    <div class="pagination">

      <el-pagination
        :current-page="currentPage"
        :page-sizes="[10, 30, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

  </div>
</template>

<script>
import {selectMaterialType,superwordSelectInfo,superwordBatchDelete,updateComposition,updateUnComposition,unDownLoad} from '@/api/file/carving'
export default {
  data() {
    return {
      isLock: false,
      pageSize: 10,
      param:'1800',
      total: 0,
      currentPage: 1,
      multipleSelection: [],
      compositionStatus:[{
        value: '0',
        label: '未拼版'
      }, {
        value: '1',
        label: '已拼版'
      }],
      downloadStatus: [{
        value: '0',
        label: '未下载'
      }, {
        value: '1',
        label: '已下载'
      }],
      cellClassName: {
        shortcuts: [
        {
            text: '最近一天',
            onClick(picker) {
              const end = new Date()

              const start = new Date()

              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三天',
            onClick(picker) {
              const end = new Date()

              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()

              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()

              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()

              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89)
              picker.$emit('pick', [start, end])
            }
          }
        ]

      },
      date: '',
      conTract: [],
      buttonInfo:[],
      MiniFindDTO:{
        fileName:'',
        materialType:'',
          startTime: '',
          endTime: '',
          access: '',
          productType: '超级字',
          fileType:'灌胶文件',
          downloadStatus:'0',
          compositionStatus:'0'
      },
      searchForm: {
        startTime: '',
        secondStartTime: '',
        number: '',
        values: ''
      },
      DeleteDTO:{
        id:'',
        status:''
      }
    }
  },
  beforeMount(){

  },

  async  mounted() {
    this.MiniFindDTO.access=localStorage.getItem("access")
    this.getTableData();
  },
  methods: {
    styleBack({ row, column, rowIndex, columnIndex }) {
      // if (columnIndex == 0) {
      //   return { color: '#0c87ef' }
      // }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getTable()
    },
    handleCurrentChange(val) {

      this.currentPage = val
      this.getTable()
    },
  async  getTableData() {
    await  selectMaterialType(this.MiniFindDTO).then((res)=>{
      if(res.data.code===10000){
            this.buttonInfo=res.data.data
           this.MiniFindDTO.materialType=res.data.data[0]
          }
    })
      superwordSelectInfo(this.currentPage, this.pageSize, this.MiniFindDTO).then((res) => {
        this.conTract = res.data.data.records
        this.total = Number(res.data.data.total)
      })
    },

    getCurrentTime() {
      //获取当前时间并打印
      var _this = this;
  let yy = new Date().getFullYear();
  let mm = new Date().getMonth()+1;
  let dd = new Date().getDate();
  let hh = new Date().getHours();
  let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
  let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
  _this.gettime = yy+'年'+mm+'月'+dd+'日'+hh+'点'+mf+'分'+ss+'秒';
  console.log(_this.gettime)
  return _this.gettime;
  },
    handleDelete(row) {
      if(this.multipleSelection.length==0){
          this.$message({
            type: "error",
            message: "sorry,你还没有勾选任何文件呢!"
          });
          return;
        }
    this.$confirm('您真的确定要删除吗？\n\n请确认！！！！！', '删除确认', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        superwordBatchDelete(this.multipleSelection).then((res) => {
          if (res.data.msg === '操作成功') {
            this.$message({
              type: 'success',
              message: '删除成功!',
            }),
            this.getTable()

          } else if (res.data.msg !== '操作成功') {
            this.$message({
              type: 'info',
              message: res.data.data
            })
          }
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
  },
  updateComposition(){
    updateComposition(this.multipleSelection).then((res)=>{
      if(this.multipleSelection.length==0){
          this.$message({
            type: "error",
            message: "sorry,你还没有勾选任何文件呢!"
          });
          return;
        }
      if(res.data.code===10000){
        if (res.data.msg === '操作成功') {
            this.$message({
              type: 'success',
              message: '拼版成功!',
            }),
            this.getTable()

          } else if (res.data.msg !== '操作成功') {
            this.$message({
              type: 'info',
              message: res.data.data
            })
          }
          }
    })
  },
  updateUnComposition(){
    updateUnComposition(this.multipleSelection).then((res)=>{
      if(this.multipleSelection.length==0){
          this.$message({
            type: "error",
            message: "sorry,你还没有勾选任何文件呢!"
          });
          return;
        }
      if(res.data.code===10000){
        if (res.data.msg === '操作成功') {
            this.$message({
              type: 'success',
              message: '返回拼版成功!',
            }),
            this.getTable()

          } else if (res.data.msg !== '操作成功') {
            this.$message({
              type: 'info',
              message: res.data.data
            })
          }
          }
    })
  },
  unDownLoad(){
    unDownLoad(this.multipleSelection).then((res)=>{
      if(this.multipleSelection.length==0){
          this.$message({
            type: "error",
            message: "sorry,你还没有勾选任何文件呢!"
          });
          return;
        }
      if(res.data.code===10000){
        if (res.data.msg === '操作成功') {
            this.$message({
              type: 'success',
              message: '返回下载成功!',
            }),
            this.getTable()

          } else if (res.data.msg !== '操作成功') {
            this.$message({
              type: 'info',
              message: res.data.data
            })
          }
          }
    })
  },

  find(data){
    this.MiniFindDTO.materialType=data
     this.getTable();
  },

  getTable(){
     selectMaterialType(this.MiniFindDTO).then((res)=>{
      if(res.data.code===10000){
            this.buttonInfo=res.data.data
       //    this.MiniFindDTO.materialType=res.data.data[0]
          }
    })
      superwordSelectInfo(this.currentPage, this.pageSize, this.MiniFindDTO).then((res) => {
        this.conTract = res.data.data.records
        this.total = Number(res.data.data.total)
      })
  },
    deleteInfo(){
      bathDeleteFile(this.multipleSelection).then((res) => {
          if(res.data.code===10000){
            this.getTable()
          }
      })
    },

    handleSelectionChange(val) {
      this.DeleteDTO=val
      this.multipleSelection = val;
    },
    // 导出
    exportExcelData() {
      exportData(this.searchForm, this.currentPage, this.total)
        .then((res) => {
          if (res.status == 200) {
            exportExcel(res.data, res)
            this.$message({
              type: 'success',
              message: '导出成功!'
            })
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    chooeDate(e) {
      // console.log(e)
      if (e) {
        this.MiniFindDTO.startTime = e[0]
        this.MiniFindDTO.endTime = e[1]
      } else if (!e) {
        this.MiniFindDTO.startTime = ''
        this.MiniFindDTO.endTime = ''
      }
    },
    // 搜索
    serchInfo() {
      this.getTableData()
    },

    submit() {
    if(this.multipleSelection.length==0){
          this.$message({
            type: "error",
            message: "sorry,你还没有勾选任何文件呢!"
          });
          return;
        }
        this.$message({
              type: 'success',
              message: '正在死命下载中,请稍等!!!!',
            }),
    fetch("api/serviceCenter/miniUpload/downLoad", {
    body: JSON.stringify(this.multipleSelection),
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },

  }).then(res => {
    this.getTable()
    res.blob().then(blob => {
      // 转化为blobURL后再通过a标签下载
      console.log(window.URL.createObjectURL(blob))
      const blobUrl = window.URL.createObjectURL(blob);
      const a = window.document.createElement('a');
      a.href = blobUrl;
      let date= this.getCurrentTime();
      a.download = date+'灌胶文件.zip';
      a.click();
      window.URL.revokeObjectURL(blobUrl);

    });
  });
  }
}
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin: 20px;
}
.body {
  overflow: auto;
}

.pagination {
  margin-top: 10px;
  margin-right: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  position: relative;
}
.el-pagination ::v-deep.el-pagination__total {
  line-height: 36px;
}
</style>
